import React from 'react';
import styled from 'styled-components';

const Title = styled.label`
    margin: 0 10px 8px 0;
    font-weight: ${props => props.defaultOne ? 400 : 600};
    color: #121180;
`;

const CheckboxField = styled.input`
    width: 18px;
    height: 18px;
    border-radius: 3px;
    border: 1px solid #ddd;
    margin: ${props => props.isArabic ? '0 0 0 10px' : '0 10px 0 0'};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    :focus{
        outline: none;
        border: 1px solid #64A6BD;
    }
`;

const Checkbox = ({isArabic, disabled, label, arabiclabel, value, onChange, multiOnChange, required, options, error}) => {
    let defaultOne = (options === undefined) || (options && options.length === 0);
    return(
        <div className="d-flex flex-column justify-content-start">
            <div className={"d-flex align-items-center my-3 " + (isArabic ? 'arabic' : '')}>
                {defaultOne && <CheckboxField type='checkbox' isArabic={isArabic} id={label} name={label} onChange={onChange} checked={value} disabled={disabled} />}
                <Title defaultOne={defaultOne} className={"cursor-" + (disabled ? "disabled" : "pointer") + " mb-0"} htmlFor={label}>{isArabic ? arabiclabel : label} {required && <span style={{color: 'red', marginLeft: '2px'}}>*</span>}</Title>
            </div>
            <div>
                {options && options.map(({label: englishLabel, arabicLabel: arabicOption}, index) => <div className={"d-flex align-items-center my-2 " + (isArabic ? 'arabic' : '')} key={index}>
                    <CheckboxField disabled={disabled} type='checkbox' isArabic={isArabic} id={englishLabel} checked={value && value.includes(englishLabel)} onChange={e => multiOnChange(label.toLowerCase(), englishLabel)} />
                    <label className={"cursor-" + (disabled ? "disabled" : "pointer") + " mb-0"} htmlFor={englishLabel}>{isArabic ? arabicOption : englishLabel}</label>
                </div>)}
            </div>
            {error && <p className="text-danger m-0">{error}</p>}
        </div>
    );
};

export default Checkbox;